<div *ngIf="showWarning||showSuccess" class="successMsg">  
  <span class="warning-img"><i class="material-icons">warning</i></span>
  <h4 class="warningHed">{{ "welcomePackage.warningheader" | cxTranslate }}    
  </h4>
  <div *ngIf="showSuccess" class="cartMsg">
    <i class="material-icons" (click)="showSuccess=!showSuccess">close</i>
    <p *ngFor="let quoteUnavailables of quoteUnavailable ; let i = index">
        {{ "welcomePackage.part" | cxTranslate }} # {{quoteUnavailables.partNumber}}<span *ngIf="(i < quoteUnavailable.length-1)">,</span>
    </p>
    <span>{{ "welcomePackage.quoteError" | cxTranslate }}</span>
  </div>
  <div *ngIf="showWarning" class="cartError">
    <i class="material-icons" (click)="showWarning=!showWarning">close</i>
    <p>{{ "welcomePackage.cartError" | cxTranslate }}</p>
  </div>
</div>
<div class="equipment-detail" *ngIf="!noData">
    <div class="row">
        <div class="backLink" (click)="searchPrd()">
            <i class="material-icons">keyboard_arrow_left</i>{{ "welcomePackage.backResultIcon" | cxTranslate }}
        </div>
        <div class="selectedItem">
            <div class="itemDetail">
                <label>{{ "welcomePackage.equipmentSerialNoLabel" | cxTranslate }}</label>
                <span>{{serialNo}}</span>
            </div>
            <!-- <div class="itemDetail">
                <label>{{ "welcomePackage.equipmentPartNoLabel" | cxTranslate }}</label>
                <span>{{partNo}}</span>
            </div> -->
            <!-- <div class="itemDetail">
                <label>{{ "welcomePackage.equipmentPartDescriptionLabel" | cxTranslate }}</label>
                <span>{{partDescription}}</span>
            </div>  -->
        </div> 
        <!-- <div class="selectedItem">
          <div class="itemDetail salesOrder">
            <label>{{ "welcomePackage.equipmentsalesOrderRefLabel" | cxTranslate }}</label>
            <span>{{salesOrderRef}}</span>
        </div> 
      </div> -->
        <div class="tb-content">
            <h4 class="header">{{ "welcomePackage.billMaterialHeader" | cxTranslate }}</h4>
                <div class="sub-content">
                  <div class="custom-control custom-checkbox">
                      <input id="master" type="checkbox"
                      class="custom-control-input"
                      [indeterminate]="client.indeterminated"
                      [checked]="client.checked"
                      (click)="onMasterClick(client, $event);">
                      <label for="master" class="custom-control-label"></label>
                  </div>
                  <div class="cart" 
                  *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async)" 
                  (click)="buyQuote()">
                      <i class="material-icons mr-2">shopping_cart</i>
                      <span>{{ "welcomePackage.buy" | cxTranslate }}</span>
                  </div>
                  <div class="receipt"
                  *ngIf="(checkUserEnabled(accessibility.QUOTABILITYFLAG) | async)" 
                    (click)="getQuote()">
                      <i class="material-icons mr-2">receipt</i>
                      <span>{{ "welcomePackage.getAQuote" | cxTranslate }}</span>
                  </div>

                  <div class="date-picker-conatiner">
                    <div class="apply-all-holder">
                      <vs-date-picker
                        class="apply-all-date"
                        (selectedDate)="dateChangeAll($event)"
                        [filterWeekend]="filterWeekend"
                        [defaultDate]="allRequestedShipDate"
                        [dateInputLabel]="'crd'"
                        [min]="minDate"
                        [ngClass]="{ 'crd-error': isAllRSDapply }"
                      >
                      </vs-date-picker>
                      <button
                        class="vs-tertiary-btn apply-btn-button"
                        (click)="applyReqShipDateAll()"
                      >
                        <span>{{ "savedCart.applyToAll" | cxTranslate }}</span>
                      </button>
                    </div>
                  </div>
                </div>            
                <div class="dataTable" *ngIf="tableData$|async as tableData else loading">
                    <div class="row">    
                        <div class="example-container mat-elevation-z8 tb-parent"> 
                          <div class="itemCount">{{totalResult}} {{ "welcomePackage.itemFound" | cxTranslate }}</div>
                          <app-scroll-container
                          *ngIf="!isLoadMoreInProgress"
                          [more]="true"
                          [scrollDelay]="2000"
                          [scrollOffset]="2000"
                          (scrolled)="loadMoreOrders()"
                          [class.full]="full"
                          [class.part]="!full"
                        >
                            <mat-table #table [dataSource]="dataSource">                              

                              <ng-container matColumnDef="check box">
                                <mat-header-cell *matHeaderCellDef class="tb-heading"></mat-header-cell>
                                <mat-cell *matCellDef="let element" class="tb-row"> 
                                    <div class="vs-checkbox">
                                      <input id="{{element.partNumber}}" type="checkbox" [value]="element.partNumber"
                                      (change)="updateCheckedOptions($event,element)" [checked]="element.selected"/>
                                      <label for="{{element.partNumber}}"></label>
                                    </div>
                                  </mat-cell>
                              </ng-container>

                           
                              <ng-container matColumnDef="Part Number">
                                <mat-header-cell *matHeaderCellDef class="tb-heading">{{ "welcomePackage.partNoHeader" | cxTranslate }}</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="tb-row">{{element.partNumber}}</mat-cell>
                              </ng-container>
                          
                              <!-- Weight Column -->
                              <ng-container matColumnDef="Description">
                                <mat-header-cell *matHeaderCellDef class="tb-heading">{{ "welcomePackage.descriptionHeader" | cxTranslate }}</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="tb-row">
                                  <div  class="part-desp"
                                    matTooltipClass="vs-tooltip"
                                    matTooltipPosition="below"
                                    matTooltip="{{ element.partDescription }}"
                                  > {{element.partDescription}} 
                                  </div>
                                </mat-cell>
                              </ng-container>
                        
                              <ng-container matColumnDef="SparesIndicator">
                                <mat-header-cell *matHeaderCellDef class="tb-heading">{{ "welcomePackage.sparesIndicatorHeader" | cxTranslate }}
                                  <i class="material-icons" (click)="decreasing()">keyboard_arrow_up</i>
                                  <i class="material-icons" (click)="increasing()">keyboard_arrow_down</i>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="tb-row">{{element.sparesIndicator}}</mat-cell>
                              </ng-container>
                        
                              <ng-container matColumnDef="Ordered Qty">
                                <mat-header-cell *matHeaderCellDef class="tb-heading">{{ "welcomePackage.bomQtyHeader" | cxTranslate }}</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="tb-row">{{element.bomQty}}</mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Recommended Qty">
                                <mat-header-cell *matHeaderCellDef class="tb-heading">{{ "welcomePackage.reccomQuantityHeader" | cxTranslate }}</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="tb-row recomend"><strong class="mr-1"> {{ "welcomePackage.quantity" | cxTranslate }} </strong>
                                  <div class="vs-quantity-counter">
                                    <button
                                       class="substract-btn vs-tertiary-btn" (click)="decreaseQuantity(element)" [disabled]="element.quantity < 2 ? true : false">
                                      <i class="material-icons">remove</i>
                                    </button>                    
                                    <input type="number" id="{{element.partNumber}}" class="qty-input" [(ngModel)]="element.quantity" 
                                    step="1" tabindex="0" min="1" max="9999" 
                                    (keypress)="preventE($event,element)" (keydown)="keyDown($event,element)" (blur)="onBlur(element)"/>    
                                    <button class="add-btn vs-tertiary-btn" (click)="increaseQuantity(element)">
                                      <i class="material-icons">add</i>
                                    </button>
                                  </div><span class="ml-1">{{ "welcomePackage.each" | cxTranslate }}</span>
                                </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Requested Ship Date">
                                <mat-header-cell *matHeaderCellDef class="tb-heading">Requested Ship Date</mat-header-cell>
                                <mat-cell *matCellDef="let element" class="tb-row">
                                  <vs-date-picker
                                    class="element-date-picker"
                                    (selectedDate)="dateChange($event, element)"
                                    [filterWeekend]="filterWeekend"
                                    [defaultDate]="element.customerRequestedDate"
                                    [dateInputLabel]="'crd'"
                                    [min]="minDate"
                                    [ngClass]="{ 'crd-error': (!element.customerRequestedDate && element.selected) }"
                                  >
                                  </vs-date-picker>
                                </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="cart">
                                <mat-header-cell *matHeaderCellDef class="tb-heading"></mat-header-cell>
                                <mat-cell *matCellDef="let element" class="tb-row">
                                  <i class="material-icons disabl" 
                                  *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async)  && !element.bomSellabilityFlag" disabled
                                  matTooltipClass="vs-tooltip"
                                  matTooltipPosition="below"
                                  matTooltip='{{ "welcomePackage.buyTooltipTxt" | cxTranslate }}'
                                  >
                                  shopping_cart
                                  </i>
                                  <i class="material-icons" 
                                  *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async)  && element.bomSellabilityFlag" 
                                  (click)="singleBuyQuote(element)"
                                  matTooltipClass="vs-tooltip"
                                  matTooltipPosition="below"
                                  matTooltip='{{ "welcomePackage.buyTooltipTxt" | cxTranslate }}'
                                  >
                                  shopping_cart</i>
                                </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="receipt">
                                <mat-header-cell *matHeaderCellDef class="tb-heading"></mat-header-cell>
                                <mat-cell *matCellDef="let element" class="tb-row" >
                                  <i class="material-icons"
                                  matTooltipClass="vs-tooltip"
                                  matTooltipPosition="below"
                                  matTooltip='{{ "welcomePackage.getQuoteTooltipTxt" | cxTranslate }}'
                                  *ngIf=" (checkUserEnabled(accessibility.QUOTABILITYFLAG) | async)"
                                  (click)="singleGetQuote(element)"
                                  >receipt</i>
                                </mat-cell>
                              </ng-container>
                              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                              <mat-row *matRowDef="let dataSource; columns: displayedColumns;"></mat-row>
                            </mat-table>
                          </app-scroll-container>
                          <div *ngIf="isLoadMoreInProgress">
                            <cx-spinner></cx-spinner>
                          </div>
                          <div class="currently-loading-spinner" *ngIf="currentlyLoading && !isLoadMoreInProgress">
                            <cx-spinner></cx-spinner>
                          </div>
                          <div class="itemCount">{{totalResult}} {{ "welcomePackage.itemFound" | cxTranslate }}</div>
                          </div>  
                      </div>  
                  </div>
            </div>
    </div>
</div>
<div *ngIf="noData" class="not-found">
    <div class="noData">
        <div class="not-found-content">
            <img class="img" src="../../../../../assets/img/empty-box.svg">
            <h2 class="heading">{{ "welcomePackage.noResultfoundHeading" | cxTranslate }}</h2>
            <p class="text">{{ "welcomePackage.noResultfoundMsg" | cxTranslate : { searchInput: serialNo } }}</p>
        </div>
    </div>
</div>
<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
